import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=04302a44&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=04302a44&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04302a44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04302a44')) {
      api.createRecord('04302a44', component.options)
    } else {
      api.reload('04302a44', component.options)
    }
    module.hot.accept("./ResourceDetail.vue?vue&type=template&id=04302a44&scoped=true", function () {
      api.rerender('04302a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/resource/components/ResourceDetail.vue"
export default component.exports